module.exports = __webpack_public_path__ + "static/c_7-bbfb758a214bbd21f03b25b24b964bf1.jpg";